var DISPLAY_PAGES = {
  CONTENT: 'CONTENT',
  COMPARISON: 'COMPARISON',
  DIGITAL_MARKETING: 'DIGITAL_MARKETING',
  IPX_CARDS: 'IPX_CARDS',
  MARKETPLACE: 'MARKETPLACE',
  PERSONALIZED_REC_FLOWS: 'PERSONALIZED_REC_FLOWS',
  REVIEWS: 'REVIEWS',
  ROUNDUPS: 'ROUNDUPS',
  TOOLS: 'TOOLS'
};
export { DISPLAY_PAGES };
export var LINK_TYPES = {
  BUTTON: 'BUTTON',
  LINK: 'LINK'
};
export var RATES_LINK_EDUCATION_LOANS = 'https://www.nerdwallet.com/refinancing-student-loans/pre-qualify';
export var RATES_LINK_PERSONAL_LOANS = 'https://analyze.nerdwallet.com/personal-loan/apply/personal-loan-purpose';
export var TRK_PRODUCT_LOCATION = 'MarketplaceApplyNow';